import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const FilialCtx = createContext(null);

export const FilialProvider = ({ children }) => {
  const { user } = useAuth();
  const [filiais, setFiliais] = useState([]);
  const [selecionada, setSelecionadaRaw] = useState(() => localStorage.getItem("filial_selecionada") || "");

  const carregarFiliais = useCallback(async () => {
    if (!user) {
      setFiliais([]);
      return;
    }
    try {
      const r = await api.get("/filiais/");
      setFiliais(r.data);
    } catch {
      setFiliais([]);
    }
  }, [user]);

  useEffect(() => { carregarFiliais(); }, [carregarFiliais]);

  // Sincroniza header HTTP via interceptor (já lê localStorage), aqui só persistimos
  const setSelecionada = useCallback((id) => {
    if (id && id !== "todas") {
      localStorage.setItem("filial_selecionada", id);
      setSelecionadaRaw(id);
    } else {
      localStorage.removeItem("filial_selecionada");
      setSelecionadaRaw("");
    }
  }, []);

  const filialAtual = filiais.find((f) => f.id === selecionada) || null;
  const isDiretor = user?.role === "diretor";

  return (
    <FilialCtx.Provider
      value={{
        filiais,
        selecionada,
        filialAtual,
        setSelecionada,
        isDiretor,
        carregarFiliais,
      }}
    >
      {children}
    </FilialCtx.Provider>
  );
};

export const useFilial = () => useContext(FilialCtx);
